export type HudState =
  | 'idle'
  | 'listening'
  | 'thinking'
  | 'speaking'
  | 'connecting'
  | 'error'
  | 'live-ready';

const STATE_LABEL: Record<HudState, string> = {
  idle: 'Idle',
  listening: 'Listening…',
  thinking: 'Thinking…',
  speaking: 'Speaking…',
  connecting: 'Connecting…',
  error: 'Error',
  'live-ready': 'Live ready',
};

export interface PersonaHeaderProps {
  displayName: string;
  mood: string | null;
  moodShifted: boolean;
  moodTooltip?: string;
  voice: string;
  voiceTooltip?: string;
  state: HudState;
}

export function PersonaHeader({
  displayName,
  mood,
  moodShifted,
  moodTooltip,
  voice,
  voiceTooltip,
  state,
}: PersonaHeaderProps) {
  if (!displayName) {
    return (
      <div className="persona-header persona-header-empty">
        <span className="muted">No active persona</span>
      </div>
    );
  }
  const stateCls = `state-${state}`;
  return (
    <div className={`persona-header ${stateCls}`}>
      <span className="persona-avatar" aria-hidden="true">
        [•]
      </span>
      <span className="persona-name" title={displayName}>
        {displayName}
      </span>
      <span className="persona-divider">·</span>
      <span
        className={
          'persona-mood' + (moodShifted ? ' persona-mood-shifted' : '')
        }
        title={moodTooltip}
      >
        Mood: {mood ?? 'baseline'}
      </span>
      <span className="persona-divider">·</span>
      <span className="persona-voice" title={voiceTooltip}>
        Voice: {voice}
      </span>
      <span className="persona-spacer" />
      <span className={`persona-state ${stateCls}`} aria-live="polite">
        {STATE_LABEL[state]}
      </span>
    </div>
  );
}
